import React from 'react';
import { MainLayout } from '../main-layout';
import { article } from '../advice/styles';
import { useSelector } from 'react-redux';
import { getAppendixList } from 'features/page-model/ducks/get-model';

export const Perevozchik = () => {
  const appendixList = useSelector(getAppendixList);

  return (
    <MainLayout>
      <div className={article}>
        <div className="container section">
          <div className="text parbase section">
            <p>
              <span className="rte-standard">&nbsp;</span>
            </p>
            <p>
              <span className="rte-standard">&nbsp;</span>
            </p>
            <p>
              <span className="rte-standard">&nbsp;</span>
            </p>
            <p>
              <span className="rte-standard">&nbsp;</span>
            </p>
            {appendixList?.map(a => (
              <p>
                <span className="rte-standard">
                  <a href={a?.link} download target="_blank" rel="noopener noreferrer">
                    {a?.label}
                  </a>
                </span>
              </p>
            ))}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
